export default {"src":"/_next/static/media/Crop_Fields.af09bd30.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};